import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAlitaliaComponent } from './simple-icons-alitalia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAlitaliaComponent ],
    exports:      [ SimpleIconsAlitaliaComponent ],
    bootstrap:    []
})
export class SimpleIconsAlitaliaModule {}
